import React, { useState, useEffect } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';
import { TariffCard } from '../../../../components/cards/TariffCard.jsx';
import { getFilteredTariffs } from '../../../../modules/tarif-logik.js';

export function TariffGridRender({ node, isLiveMode }) {
  const content = node.content || {};
  const [allTariffs, setAllTariffs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Hole global Tarife
  useEffect(() => {
    let active = true;
    fetch('/api/tariffs')
      .then(r => r.json())
      .then(data => {
        if (active) {
          setAllTariffs(data);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Fehler beim Laden der Tarife für GridWidget', err);
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  // Filtern
  const filtered = React.useMemo(() => {
    if (!allTariffs || allTariffs.length === 0) return [];
    
    // Wir nutzen die bestehende Logik aus tarif-logik.js
    // context Objekt für getFilteredTariffs erwartet: 
    // activeSegment, kombiFilter (boolean), activeCategoryTag (String)
    
    const context = {
      activeSegment: content.segment || 'mobile',
      kombiFilter: content.showKombiOnly === true,
      activeCategoryTag: content.category && content.category !== 'Alle' ? content.category : null,
      customQuery: ''
    };

    let result = getFilteredTariffs(allTariffs, context);
    
    // Limitieren, falls eingestellt
    if (content.maxItems && content.maxItems > 0) {
      result = result.slice(0, parseInt(content.maxItems, 10));
    }
    return result;
  }, [allTariffs, content]);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center', opacity: 0.5 }}>Lade Tarife...</div>;
  }

  if (filtered.length === 0) {
    return <div style={{ padding: '20px', textAlign: 'center', border: '1px dashed #475569', borderRadius: '8px' }}>Keine Tarife in dieser Kategorie gefunden.</div>;
  }

  return (
    <div style={{ pointerEvents: !isLiveMode ? 'none' : 'auto' }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {filtered.map(tariff => (
        <TariffCard 
          key={tariff.id} 
          {...tariff} 
          // Card Effects default to config or off in editor
          activeEvent="none"
          onSelectToggle={() => {}}
          onPrint={() => {}}
        />
      ))}
    </div>
  );
}

// Registrierung im TEF Designer
registry.register('TariffGrid', {
  label: 'Tarif-Grid (Auto)',
  icon: '🗂️', 
  category: 'tef',
  component: TariffGridRender,
  
  defaultProps: {
    content: {
      segment: 'mobile',
      category: 'Alle',
      showKombiOnly: false,
      maxItems: 4
    },
    style: {
      desktop: {
        padding: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Grid Filter Einstellungen',
          fields: [
            { name: 'content.segment', label: 'Tarif-Segment', type: 'select', options: [
              { value: 'mobile', label: 'O2 Mobile' },
              { value: 'prepaid', label: 'O2 Prepaid' },
              { value: 'blue', label: 'O2 Blue' },
              { value: 'myhome', label: 'O2 Home' },
              { value: 'data', label: 'O2 Data' }
            ]},
            { name: 'content.category', label: 'Kategorie (Badge)', type: 'select', options: [
              { value: 'Alle', label: 'Alle anzeigen' },
              { value: 'Neuvertrag', label: 'Neuvertrag' },
              { value: 'Junge Leute', label: 'Junge Leute' },
              { value: '60 Plus', label: '60 Plus' },
              { value: 'Promo Aktion', label: 'Promo Aktion' }
            ]},
            { name: 'content.showKombiOnly', label: 'Nur Kombi-Vorteil Tarife?', type: 'boolean' },
            { name: 'content.maxItems', label: 'Maximale Anzahl (0 = alle)', type: 'number', step: '1' }
          ]
        }
      ]
    }
  ]
});
